<template>
  <el-tooltip
      v-if="warranty === 'Mất bảo hành'"
      class="item"
      effect="dark"
      placement="top"
  >
    <div slot="content" style="width: 100%">
      <span style="margin-bottom: 5px">Lý do mất bảo hành:</span>
      <ul style="margin-top: 8px;">
        <li
            v-for="(reason, index) in warrantyReason"
            :key="index"
            style="list-style-type: none; margin-left: -20px"
        >
          - {{ reason }}
        </li>
      </ul>
    </div>
    <span :class="getClass" style="padding: 5px 8px; border-radius: 5px; white-space: nowrap">
      {{ warranty }}
    </span>
  </el-tooltip>

  <span
      v-else
      :class="getClass"
      style="padding: 5px 8px; border-radius: 5px; white-space: nowrap"
  >
    {{ warranty }}
  </span>
</template>

<script>
export default {
  name: "WarrantyTooltip",
  props: {
    warranty: {
      type: String,
      required: true,
    },
    warrantyReason: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getClass() {
      return this.warranty === 'Mất bảo hành'
          ? 'bg-gray text-white'
          : 'bg-green-500 text-white'
    },
  },
};
</script>

<style scoped>
.bg-gray {
  background-color: #6C6C6C;
}
.bg-green-500 {
  background-color: #1BC5BD;
}
.text-white {
  color: white;
}
</style>
